import { string, object } from 'yup';

import salesTypes from 'maps/sales-types';

import supportsOneOf from 'helpers/supportsOneOf';

const salesTypeKeys = Object.keys(salesTypes);

export default getSchema;

function getSchema(salesType) {
  if (!salesType) {
    throw new Error('Missing required argument salesType');
  }

  if (!supportsOneOf()) {
    return object({
      selectedSalesType: string().required().default(salesType),
    });
  }

  return object({
    selectedSalesType: string()
      .required()
      .oneOf(salesTypeKeys)
      .default(salesType),
  });
}
